import { AccountType } from '@repo/types/enums/accountType';

/**
 * Returns whether an account is a parent account.
 *
 * Parents are modelled on two orthogonal axes: they carry `lvl === UserLvl.STUDENT`
 * like any student, and are distinguished only by `accountType`. Guards and
 * navigation therefore have to check both — comparing `lvl` alone lets a parent
 * through every student gate.
 *
 * `accountType` is absent on legacy user records, which are always regular users.
 */
export const isParent = (accountType?: AccountType): boolean => accountType === AccountType.Parent;
